import {ProductEnum} from './productEnum';
import type {CorporateData} from './corporateDataType';

export enum XContextOperadoraEnum {
	HAP = 'Hapvida',
	CCG = 'Ccg',
	CLINIPAM = 'Clinipam',
	GNDI_MINAS = 'NdiMg',
	GNDI = 'NdiSp',
	NOTREDAME_SAUDE = 'NotreDameSaude',
}

export enum XContextTipoPlanoEnum {
	ODONTO = 'Odonto',
	SAUDE_OU_ODONTO = 'SaudeOuOdonto',
}

export const X_CONTEXT_OPERADORA_BY_PRODUCT: Record<ProductEnum, XContextOperadoraEnum> = {
	[ProductEnum.HAP]: XContextOperadoraEnum.HAP,
	[ProductEnum.CCG]: XContextOperadoraEnum.CCG,
	[ProductEnum.CLINIPAM]: XContextOperadoraEnum.CLINIPAM,
	[ProductEnum.GNDI_MINAS]: XContextOperadoraEnum.GNDI_MINAS,
	[ProductEnum.GNDI]: XContextOperadoraEnum.GNDI,
	[ProductEnum.NOTREDAME_SAUDE]: XContextOperadoraEnum.NOTREDAME_SAUDE,
};

export const CORPORATE_BY_PRODUCT: Record<ProductEnum, CorporateData> = {
	[ProductEnum.GNDI_MINAS]: {
		id: '62550256000120',
		name: 'NOTRE DAME INTERMEDICA MINAS GERAIS SAUDE S.A',
	},
	[ProductEnum.CLINIPAM]: {
		id: '76882612000117',
		name: 'CLINIPAM - CLINICA PARANAENSE DE ASSISTENCIA MEDICA LTDA',
	},
	[ProductEnum.GNDI]: {
		id: '44649812000138',
		name: 'NOTRE DAME INTERMEDICA SAUDE S.A',
	},
	[ProductEnum.HAP]: {
		id: '63554067000198',
		name: 'HAPVIDA ASSISTENCIA MEDICA S.A.',
	},
	[ProductEnum.CCG]: {
		id: '00773639000100',
		name: 'CENTRO CLINICO GAUCHO LTDA',
	},
	[ProductEnum.NOTREDAME_SAUDE]: {
		id: '44649812000138',
		name: 'NOTRE DAME SAUDE S.A',
	},
};
